import React, { useState } from "react";
import { Alert } from "@mui/material";
import MediaPreviewModal from "../../Modal/MediaPreviewModal";
import { useTranslation } from "../../../context/Internationalization";
import useFileSource from "./useFileSource";

export default function FilePreview({ file, onClose, actions }) {
  const { t } = useTranslation();
  const { url, name, previewKind } = useFileSource(file);
  const [failed, setFailed] = useState(false);
  return (
    <MediaPreviewModal open onClose={onClose} title={name} actions={actions}>
      {failed || !previewKind ? (
        <Alert severity="info">{t("file_preview_unavailable")}</Alert>
      ) : (
        url &&
        (previewKind === "image" ? (
          <img src={url} alt={name} onError={() => setFailed(true)} />
        ) : (
          <video src={url} controls autoPlay onError={() => setFailed(true)} />
        ))
      )}
    </MediaPreviewModal>
  );
}
